<template>
  <main>
    <section class="flex center relative" :style="`height: calc(100dvh - ${pxToRem(header.height.full)})`">
      <base-picture class="absolute-0 -z-1" fit="cover" :src="intro.bg" />
      <div class="c-white text-center space-y-5 lg:space-y-8">
        <h2 v-html="intro.title" class="display-2" />
        <p v-html="intro.copy" class="text-sm lg:text-md" />
        <div class="f-col gap-3 center">
          <vf-button
            v-for="({ text, to }, key) in intro.cta"
            :key
            style="width: 16.25rem"
            :to
            variant="primary-inverse"
          >
            {{ text }}
          </vf-button>
        </div>
      </div>
      <div class="flex center bottom-0 absolute z-1">
        <custom-arrow-scroll class="c-white" :size="{ sm: 'sm', md: 'md' }" style="bottom: 0.5rem" />
      </div>
    </section>
    <section class="relative h-screen">
      <div class="flex full center relative" :style="`background: url(${promo.bg}) fixed center / cover`">
        <div v-motion-fade-up-visible class="f-col gap-8 center z-1 lg:flex-row-reverse">
          <div class="w-1/2 lg:pl-22">
            <base-picture class="w-full" height="253" :src="promo.src" width="242" />
          </div>
          <div class="space-y-5 <lg:text-center lg:space-y-8" style="max-width: 31.25rem">
            <h2 v-html="promo.title" class="c-white title-2" />
            <p v-html="promo.copy" class="text-sm c-white lg:text-md <lg:hidden" />
            <p v-html="promo.copyMobile" class="text-sm c-white lg:hidden" />
            <div class="m-a f-col gap-3 w-65 lg:flex-row lg:w-full">
              <vf-button v-for="({ text, to }, key) in promo.cta" :key class="grow" :to variant="tertiary-inverse">
                {{ text }}
              </vf-button>
            </div>
            <div class="text-sm c-white px-2 lg:px-0">
              <span class="fw-medium">{{ promo.footnote.title }}</span>
              <span class="<lg:hidden"> | </span>
              <span>{{ promo.footnote.description }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <base-link class="md:flex" :to="twoImages.to">
        <base-picture
          v-for="(src, key) in twoImages.items"
          :key
          class="w-full aspect-square lg:w-1/2"
          fit="cover"
          height="680"
          :src
          width="720"
        />
      </base-link>
    </section>
    <section class="c-white bg-black" style="padding-block: 6.25rem">
      <div class="container lg:text-center">
        <h2 v-html="carousel.title" class="mb-9 display-2" />
        <p v-html="carousel.copy" class="mb-25 lg:subtitle-1" />
      </div>
      <vf-carousel class="w-full" style-container="justify-content: space-around">
        <div
          v-for="({ name, copy, src, imageWidth, cta }) in carousel.products"
          :key="name"
          class="c-white text-center snap-center"
          style="padding-inline: 1.25rem"
        >
          <base-picture height="270" :src :width="imageWidth" />
          <h3 v-html="name" class="c-white mb-6 mt-8 title-1" />
          <p v-html="copy" class="text-sm c-white mb-6 text-center lg:text-md" />
          <div class="space-y-3">
            <vf-button
              v-for="({ text, to }) in cta"
              :key="text"
              class="w-full"
              :to
              variant="primary-inverse"
            >
              {{ text }}
            </vf-button>
          </div>
        </div>
      </vf-carousel>
    </section>
  </main>
</template>

<script lang="ts" setup>
definePageMeta({ header: { transparent: true } })

const { data, error } = await useApi().internal.getStaticPage('our-icons/nuptse')
if (!data.value) throw createError({ ...error.value!, fatal: true })
const { carousel, twoImages, intro, promo } = data.value

const header = useHeaderStore()
</script>
